import { h, Component } from "preact";
import AdditionalQuestion from "./additionalQuestion/AdditionalQuestion";

/**
 * Display additional questions per order
 *
 * @param {object, array} { additionalQuestions, tickets }
 * @returns additional questions
 */
const OrderQuestions = ({
  additionalQuestions,
  tickets,
  formName,
  orderAdditionalQuestions,
  changeFieldValue
}) => {
  const ticketTypeIds = tickets ? tickets.map(t => t.ticketTypeId) : [];

  const orderQuestions = additionalQuestions.filter(question => {
    if (!question.perOrder) {
      return false;
    }
    if (question.appliesTo && question.appliesTo.length) {
      const ticketFound = question.appliesTo.some(function(id) {
        return ticketTypeIds.indexOf(id) >= 0;
      });
      return ticketFound;
    }
    return true;
  });
  return (
    <div>
      {orderQuestions.map(question => {
        question.name = `order.additionalFields.${question._id}`;
        return (
          <AdditionalQuestion
            question={question}
            formName={formName}
            orderAdditionalQuestions={orderAdditionalQuestions}
            orderAdditionalFields={orderQuestions}
            changeFieldValue={changeFieldValue}
          />
        );
      })}
    </div>
  );
};

export default OrderQuestions;



// WEBPACK FOOTER //
// ./routes/details/OrderQuestions.js